export default __webpack_public_path__ + "src/images/packages/witklipfontein-eco-lodge/9e59506d4fd2f833f79b8f8718b9156c-4.jpg";